/* istanbul ignore file -- remove once added tests */
import { useEffect, useRef } from "react";
import styles from "./VideoTile.module.css";
export function VideoTile(props) {
    const { width, height, title, videoUrl, children } = props;
    const videoEl = useRef(null);
    useEffect(() => {
        if (videoEl.current) {
            // Catch errors to avoid errors when calling pause() in tests
            // See https://developer.chrome.com/blog/play-request-was-interrupted/
            void videoEl.current.play().catch(() => {
                console.error("Video play was interrupted");
            });
        }
    }, [videoEl]);
    const style = {
        ...(width ? { width } : {}),
        ...(height ? { height } : {}),
    };
    return (<div style={style} className={styles.tileContainer} data-testid="spotlightHighlightTile">
      <div className={styles.videoContainer}>
        <video ref={videoEl} className={styles.video} src={videoUrl} playsInline loop muted title={title || ""}/>
      </div>

      {/* Children are rendered as an overlay above the tile */}
      <div className={styles.overlay}>{children}</div>
    </div>);
}
